const compareDOMOrder = (refA, refB) => {
    if (!refA.current || !refB.current) {
        return 0;
    }
    if (refA.current.compareDocumentPosition(refB.current) &
        Node.DOCUMENT_POSITION_FOLLOWING) {
        // refA is followed by refB
        return -1;
    }
    if (refA.current.compareDocumentPosition(refB.current) &
        Node.DOCUMENT_POSITION_PRECEDING) {
        // refA is preceded by refB
        return 1;
    }
    return 0;
};
/**
 * Non-negative modulo calculation
 *
 * @param a dividend
 * @param n divisor
 * @returns remainder
 */
const mod = (a, n) => ((a % n) + n) % n;

export { compareDOMOrder, mod };
//# sourceMappingURL=util.js.map
